/**
 * The portal pool's group that marks a person as Arcanum staff (TASK-630).
 * Every portal Lambda refuses a caller outside it, and the identity pool
 * gives such a person no AWS access, so the pages refuse them too. The infra
 * and the Lambdas use the same name (`DEFAULT_STAFF_GROUP` in
 * lib/portal-caller.ts).
 */
export const STAFF_GROUP = 'portal-staff';
